import VehicleCardBadge from '.';

export default function HotCarBadge(): JSX.Element {
  return <VehicleCardBadge badgeText="hot car" badgeClass="hot-car-badge" />;
}
